// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader--PageHeader--S9D6Y1v","Title":"PageHeader--Title--3kX9Z4E","Description":"PageHeader--Description--2PQJZdC","Btns":"PageHeader--Btns--1Wg-tTQ"};